var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploader-list"},[_vm._t("default",[_c('ul',_vm._l((_vm.fileList),function(file){return _c('li',{key:file.id},[_c('uploader-file',{attrs:{"file":file,"list":true}})],1)}),0)],{"fileList":_vm.fileList})],2)}
var staticRenderFns = []

export { render, staticRenderFns }